setActiveFavouriteTab()

$(document).on('click', '.favourite-tabs .compare__tab', function(e) {
    $(this).siblings(".compare__tab").removeClass("_active")
    $(this).addClass("_active")
    setActiveFavouriteTab()
    $(this).parents(".favourite-tabs").removeClass("_active")
})

function setActiveFavouriteTab() {
    $(".favourite-tabs__selected").html($(".compare__tab._active span").text())
}

$(".favourite-tabs__current").click(function () {
    $(this).parents(".favourite-tabs").toggleClass("_active")
})

$(document).mouseup(function(e) {
    var div = $('.favourite-tabs');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if($(div).hasClass("_active")){
            $(div).removeClass("_active")
        }
    }
});

function cartCalc(){
    $('.cartcalc .ccalc-minus').click(function(){
        let a = $(this).closest('.cartcalc').find('input').val();
        if(a>1){
            let b = +a-1;
            $(this).closest('.cartcalc').find('input').val(b);
        }else{
            $(this).closest('.cartcalc').find('input').val(a);
        }
    });
    $('.cartcalc .ccalc-plus').click(function(){
        let a = $(this).closest('.cartcalc').find('input').val();
        let b = +a+1;
        $(this).closest('.cartcalc').find('input').val(b);
    });
}

cartCalc()
